export default function WhoIsThisProductFor() {
    return {
        title: 'Who is this Product for?',
        paragraphs: [
            '<div>Review your book of business for opportunities:<div>',
            '<ul class="mt-2"><li class="pl-2">On-track and at risk-clients in Goals Planning System</li><li class="pl-2">Target early and mid-late career clients</li><li class="pl-2">Working professionals and self-employed individuals</li><li class="pl-2">Small business owners</li></ul>',
            '<div>Conversation Starters:</div>',
            '<ul class="mt-2 mb-0"><li class="pl-2">Are you protecting your most valuable asset?</li><li class="pl-2">Are you protecting your ability to save for retirement?</li><li class="pl-2">How long could your business stay open if you became too sick or hurt to run it?</li></ul>',
        ]
    }
}


// WEBPACK FOOTER //
// ./src/components/Common/data/products/disability-insurance/WhoIsThisProductData.js